<label for="{{inputId}}" class="floating-label" *ngIf="label">{{ label | translate }}</label>
<input class="input-quantity" type="text" [id]="inputId" [maxlength]="maxLength" [(ngModel)]="value"
       [placeholder]="placeholder" [disabled]="disabled" [class.gray]="disabled" (change)="onChange()"
       (keydown)="onKeydown($event)" (click)="$event.target.select()" />